const stereo_camera_tab_data = [
  {
    id: 0,
    title: "General",
    path: "general",
    dynamicRoute: true,
  },
  {
    id: 1,
    title: "3D Capture",
    path: "stereo",
    dynamicRoute: true,
  },
  {
    id: 2,
    title: "Diagnostics",
    path: "stereo-diagnostics",
    dynamicRoute: true,
  },
  {
    id: 3,
    title: "Settings",
    path: "settings",
    dynamicRoute: true,
  },
  {
    id: 4,
    title: "Chat",
    path: "chat",
    dynamicRoute: true,
  },
];

export default stereo_camera_tab_data;
